import { inject, Injectable } from '@angular/core';
import { JobInsightsApiService } from '../infrastructure/job-insights/insights-api.service';

@Injectable({ providedIn: 'root' })
export class JobInsightsTrackingFacade {
  private readonly _insightsApi = inject(JobInsightsApiService);

  trackClick(viewId: number): void {
    this._insightsApi.trackJobTitleClick(viewId).subscribe();
  }
}
